import { Box, Container, Skeleton, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

const SkeletonLoaderHeroSection = ({ height }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3 },
        py: { xs: 4, sm: 8 },
        mx: { xs: 2, sm: 5 },
        my: { xs: 2, sm: 5 },
        borderRadius: 8,
        bgcolor: 'grey.100',
        minHeight: height || { xs: '300px', md: '450px' },
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: "-100%",
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
          animation: "shimmer 1.5s infinite",
        },
        "@keyframes shimmer": {
          "0%": { left: "-100%" },
          "100%": { left: "100%" },
        },
      }}
    >
      <Container 
        maxWidth="lg" 
        sx={{
          width: '100%',
          px: { xs: 0, sm: 0, md: 3 }
        }}
      >
        {/* Main heading skeleton */}
        <Box sx={{ 
          textAlign: 'center',
          mb: 3,
          mt: { xs: 6, md: 0 },
          paddingX: { xs: 4, md: 15 }
        }}>
          <Skeleton
            variant="text"
            sx={{
              fontSize: { xs: '36px', sm: '36px', md: '3.9rem' },
              height: { xs: '44px', sm: '56px', md: '72px' },
              width: '80%',
              mx: 'auto',
              mb: 1
            }}
          />
          <Skeleton
            variant="text"
            sx={{
              fontSize: { xs: '36px', sm: '36px', md: '3.9rem' },
              height: { xs: '44px', sm: '56px', md: '72px' },
              width: '60%',
              mx: 'auto'
            }}
          />
        </Box>

        {/* Subtitle skeleton */}
        <Box sx={{ 
          textAlign: 'center',
          mb: { xs: 3, md: 5 },
          paddingX: 5
        }}>
          <Skeleton
            variant="text"
            sx={{
              fontSize: '16px',
              height: '24px',
              width: '70%',
              mx: 'auto',
              mb: 1
            }}
          />
          <Skeleton
            variant="text"
            sx={{
              fontSize: '16px',
              height: '24px',
              width: '50%',
              mx: 'auto'
            }}
          />
        </Box>

        {/* Search bar skeleton */}
        <Box sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          mt: -2
        }}>
          <Box sx={{
            marginLeft: { xs: '16px', md: 'auto' },
            marginRight: { xs: '16px', md: 'auto' },
            maxWidth: { xs: '100%', md: '800px' },
            width: { xs: 'calc(100% - 32px)', md: '800px' }
          }}>
            <Skeleton
              variant="rounded"
              sx={{
                height: { xs: '48px', md: '56px' },
                width: '100%',
                borderRadius: 2
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SkeletonLoaderHeroSection;